import { FC } from 'react';
import { PageTitle, PageLink } from '../../../../_metronic/layout/core';
import { View } from './components/View';

const PedidosPage: FC = () => {
  const breadCrumbs: Array<PageLink> = [
    {
      title: 'Ventas',
      path: '/ventas/pedidos',
      isSeparator: false,
      isActive: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Mis pedidos</PageTitle>
      <View />
    </>
  );
};

export { PedidosPage };
